export default [
    {
        path: '/platinum/footer-links',
        props: true,
        component: () => import('@/views/PlatinumFooterLink'),
    },
];
